import { THEME } from '@Theme';
import { StyleSheet } from 'aphrodite';
import { HEADER_CELL_TEXT } from '../../../../components/DataGrid/styles';

const {
	colors,
	common: { borderRadius },
	spacing: { xs, sm, md },
	typography: { fontSizes },
} = THEME;

export const styleSheet = StyleSheet.create({
	columnHeader: {
		minWidth: 0,
		maxWidth: 500,
		width: 0,
	},
	loader: {
		minHeight: 500,
		alignItems: 'center',
	},
	nameColumnContent: {
		width: 'min-content',
		display: 'flex',
		flexDirection: 'row',
		alignItems: 'center',
		gap: md,
	},
	rowActive: {
		':active': {
			opacity: 0.7,
		},
	},
	rowContainer: {
		height: 50,
	},
	selectAll: {
		paddingLeft: 28,
		width: 44,
	},
	selectAllText: {
		fontSize: fontSizes.xs,
	},
	sortTrigger: {
		alignItems: 'center',
		cursor: 'pointer',
		display: 'flex',
		color: colors.text.main,
		height: '',
		padding: '',
		fontFamily: '',
		...HEADER_CELL_TEXT,
		':hover': {
			textDecoration: 'none',
		},
	},
	sortTriggerInactive: {},
	sortTriggerActive: {},
	sortIcon: {
		marginLeft: xs,
	},
	sortIconAscending: {
		transform: 'rotate3d(0,0,1, 180deg)',
	},
	sortMenu: {
		padding: 'unset',
	},
	sortMenuItem: {
		':hover': {
			backgroundColor: colors.background.dark,
			cursor: 'pointer',
		},
		':not(:last-child)': {
			borderBottom: `1px solid ${colors.border.light}`,
		},
		':first-child': {
			borderRadius: '8px 8px 0 0',
		},
		':last-child': {
			borderRadius: '0 0 8px 8px',
		},
		cursor: 'pointer',
		padding: `${xs}px ${sm}px`,
		fontSize: fontSizes.md,
	},
	databoard: {
		flex: 1,
		minHeight: 0,
		borderRadius,
		marginBottom: md,
	},
	nameColumn: {
		display: 'flex',
		flexDirection: 'row',
		alignItems: 'center',
		gap: md,
	},
	dataGrid: {
		userSelect: 'none',
		WebkitUserSelect: 'none',
		MozUserSelect: 'none',
		msUserSelect: 'none',
	},
});
